import { getService } from './service';
// import bestContrast from 'get-best-contrast-color';
import { handleError } from './ErrorReducer';

const GET_SETTINGS = 'CONFIG/GET_SETTINGS';
const CLEAR_SETTINGS = 'CONFIG/CLEAR_SETTINGS';
const SET_CONFIGURATION_MENU_ENABLED = 'CONFIG/SET_CONFIGURATION_MENU_ENABLED';
const SET_PASSWORD_VALIDATION = 'CONFIG/SET_PASSWORD_VALIDATION';
const SET_SESSION_SETTINGS = 'CONFIG/SET_SESSION_SETTINGS';
// ================  ACTIONS  ======================

export const getSettings = () => {
  return async dispatch => {
    try {
      const service = getService('settings-resources');
      const settings = await service.find({ query: { type: 'settings' } });
      dispatch({ type: GET_SETTINGS, settings });
    } catch (error) {
      dispatch(handleError(error, 'Error loading settings'));
    }
  };
};

export const clearSettings = () => dispatch => {
  dispatch({ type: CLEAR_SETTINGS });
};
export const setConfigurationMenuEnabled = data => {
  return dispatch => {
    dispatch({ type: SET_CONFIGURATION_MENU_ENABLED, payload: data });
  };
};
export const saveSettings = (type, data) => {
  const service = getService('settings-resources');
  return service.patch(type, { type: 'settings', data });
};

export const getPasswordValidation = () => async dispatch => {
  try {
    const cdr = getService('cdr');

    const [min] =
      (await cdr.get({ Path: 'Password.MinLength', CDRKey: 'PasswordValidation' })) || [];
    const [upper] =
      (await cdr.get({ Path: 'Password.RequireUppercase', CDRKey: 'PasswordValidation' })) || [];
    const [lower] =
      (await cdr.get({ Path: 'Password.RequireLowercase', CDRKey: 'PasswordValidation' })) || [];
    const [digit] =
      (await cdr.get({ Path: 'Password.RequireDigit', CDRKey: 'PasswordValidation' })) || [];
    const [special] =
      (await cdr.get({ Path: 'Password.RequireSpecialChar', CDRKey: 'PasswordValidation' })) || [];
    dispatch({
      type: SET_PASSWORD_VALIDATION,
      passwordValidation: {
        minLength: min?.ValueNumeric ?? 8,
        requireUppercase: upper?.ValueBoolean ?? true,
        requireLowercase: lower?.ValueBoolean ?? true,
        requireDigit: digit?.ValueBoolean ?? true,
        requireSpecialChar: special?.ValueBoolean ?? true,
      },
    });
  } catch (e) {
    dispatch(handleError(e));
  }
};

export const getSessionSettings = () => async dispatch => {
  try {
    const cdr = getService('cdr');
    const [enabled] =
      (await cdr.get({ Path: 'Session.Warning.Enabled', CDRKey: 'SessionSettings' })) || [];
    const [minutes] =
      (await cdr.get({ Path: 'Session.Warning.Minutes', CDRKey: 'SessionSettings' })) || [];
    dispatch({
      type: SET_SESSION_SETTINGS,
      sessionWarningEnabled: enabled?.ValueBoolean ?? false,
      sessionWarningMinutes: minutes?.ValueNumeric ?? 5,
    });
  } catch (e) {
    dispatch(handleError(e));
  }
};

// ==================  REDUCERS  ===============
const defaultConfig = {
  loaded: false,
  dictionary: {
    Statuses: [],
    CallTypes: [],
    Dispositions: [],
    EventSubTypes: [],
    RequestedActions: [],
    CallMethods: [],
    PartyRelationships: [],
    PtsPersons: [],
    NamePrefixes: [],
    NameSuffixes: [],
    AddressCategories: [],
    StreetDirections: [],
    StreetTypes: [],
    Cities: [],
    States: [],
    ESN: [],
    AddressUnitTypes: [],
    UnitActions: [],
    UnitActionModifiers: [],
  },
  options: {},
  configurationMenuEnabled: false,
  passwordValidation: {
    minLength: 8,
    requireUppercase: true,
    requireLowercase: true,
    requireDigit: true,
    requireSpecialChar: true,
  },
  sessionWarningEnabled: false,
  sessionWarningMinutes: 5,
};

export default function reducer(state = defaultConfig, action) {
  switch (action.type) {
    case GET_SETTINGS:
      return { ...state, ...action.settings, loaded: true };
    case CLEAR_SETTINGS:
      return {
        ...defaultConfig,
        passwordValidation: state.passwordValidation,
      };
    case SET_CONFIGURATION_MENU_ENABLED:
      return {
        ...state,
        configurationMenuEnabled: action.payload,
      };
    case SET_PASSWORD_VALIDATION:
      return {
        ...state,
        passwordValidation: action.passwordValidation,
      };
    case SET_SESSION_SETTINGS:
      return {
        ...state,
        sessionWarningEnabled: action.sessionWarningEnabled,
        sessionWarningMinutes: action.sessionWarningMinutes,
      };
    default:
      return state;
  }
}
